<template>
  <div>
    <div class="presets-container form-group row text-center">
        <h2 class="font-w300 push-10"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelFieldTitleAddGroup[actualLanguage] }}</h2>
        <h3 class="font-w300 push-10">{{ profileData.profileInfo.email }}</h3>
    </div>

    <div class="presets-container form-group row text-center">
        <div class="col-xs-12">
            <label for="manufacturier">{{ labelFieldGroupName[actualLanguage] }}</label>
            <input  type="text" v-model="groupInfo.groupName">
        </div>
    </div>

    <div v-if="groupInfo.groupName" class="presets-container form-group row text-center">
        <div  class="col-xs-12">
            <div class="presets-container form-group row text-center">
                <button  @click="createGroup" class="btn btn-success btn-rounded btn-save" style="width: 160px" type="button" name="button">{{ labelButtonConfirmed[actualLanguage] }}</button>
            </div>
        </div>
    </div>

    <div v-if="displayMessage" class="presets-container form-group row text-center">
        <h3 class="font-w300 push-8"><i class="fa fa-check fa-1x push-5-r "></i>{{ textDisplayMessage[actualLanguage] }}</h3>

    </div>


    </div>

  </div>

</template>


<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'CreateGroupForm',
  components: {
    Spinner
  },
    data() {
        return {
        errorMsg: '',
        groupInfo: {
            profileId: '',
            groupName: '',
        },
        displayMessage : false,

        actualLanguage : "FR",
        labelFieldTitleAddGroup: {FR: 'Ajouter un groupe au profile:', EN: 'Add group to profile'},
        labelFieldGroupName: {FR: 'Nom du groupe:', EN: 'Group name:'},
        labelButtonConfirmed:{FR: 'Créer le groupe', EN: 'Create Group'},
        textDisplayMessage: {FR: 'Groupe créé!', EN: 'Group created'},
        labelField: {FR: '', EN: ''},
        }
    },

    props:['componentState'],

    computed: {
        ...mapState('sessionStore', ['profileData','groupArborescence','actualGroup','actualBundle']),
    },


    methods: {
    createGroup() {
        this.displayMessage = '';
        this.groupInfo.profileId = this.profileData.profileId
        return this.$store.dispatch('groupStore/createNewGroupInProfile',this.groupInfo)
        .then((response) => {
            this.groupInfo.groupName = ''
            this.displayMessage=true
            
        })
  
    },


    },

created() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }


}

</script>


// WEBPACK FOOTER //
// CreateGroupForm.vue?01cef596